import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { getDocument, getItems, getHistory, transmitNfe } from '../services/api'
import EmitForm from '../components/EmitForm'
import CancelForm from '../components/CancelForm'

export default function DocumentDetail() {
  const params = useParams()
  const empCod = Number(params.empCod)
  const serie = params.serie || ''
  const numero = Number(params.numero)

  const [doc, setDoc] = useState<any>(null)
  const [items, setItems] = useState<any[]>([])
  const [history, setHistory] = useState<any[]>([])

  useEffect(() => {
    if (!empCod || !serie || !numero) return
    getDocument(empCod, serie, numero).then((d) => setDoc(d)).catch(console.error)
    getItems(empCod, serie, numero).then((r) => setItems(r || [])).catch(console.error)
    getHistory(empCod, serie, numero).then((h) => setHistory(h || [])).catch(console.error)
  }, [empCod, serie, numero])

  async function handleTransmit() {
    try {
      await transmitNfe(empCod, serie, numero)
      alert('Transmitido (mock)')
    } catch (err) {
      console.error(err)
      alert('Erro ao transmitir')
    }
  }

  return (
    <div style={{ padding: '1rem' }}>
      <h2>Documento {empCod}/{serie}/{numero}</h2>
      {doc ? (
        <div>
          <p>Cliente: {doc.cli_cod || doc.ntv_clifor}</p>
          <p>Data emissão: {doc.ntv_datemi}</p>
          <div style={{ marginTop: '1rem' }}>
            <EmitForm empCod={empCod} serie={serie} numero={numero} onSuccess={() => {}} />
            <button onClick={handleTransmit} style={{ marginLeft: '0.5rem' }}>Transmitir</button>
            <CancelForm empCod={empCod} serie={serie} numero={numero} onSuccess={() => {}} />
          </div>

          <h3 style={{ marginTop: '1rem' }}>Itens</h3>
          <ul>
            {items.map((it) => (
              <li key={it.pnv_lin}>{it.pnv_des} - {it.pnv_vl_mer}</li>
            ))}
          </ul>

          <h3>Histórico</h3>
          <ul>
            {history.map((h) => (
              <li key={h.nfehisseq}>{h.nfehisdes} - {h.nfehisusu}</li>
            ))}
          </ul>
        </div>
      ) : (
        <div>Carregando documento...</div>
      )}
    </div>
  )
}
